import { ShortCode } from '@highereducation/wordpress';
import { Section } from '@highereducation/hen-ui';

interface SectionShortcodeProps {
  variant?: 'default' | 'light' | 'dark' | 'white-outline';
  gap?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'max';
  padding?: 'none' | 'section';
  rounded?: 'true' | 'false' | 'none' | 'sm' | 'md' | 'lg' | 'xl';
  children?: React.ReactNode;
  [key: string]: unknown;
}

/**
 * SectionShortcode - Shortcode wrapper for Section layout component
 *
 * Container component with background, padding, and spacing.
 * Replaces manual `<section>` tags and div containers with styling.
 *
 * Supported shortcode attributes:
 * - variant: 'default' | 'light' | 'dark' | 'white-outline' (default: 'default')
 * - gap: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'max' (default: '3xl')
 * - padding: 'none' | 'section' (default: 'none')
 * - rounded: 'true' | 'false' | 'none' | 'sm' | 'md' | 'lg' | 'xl' (default: 'false')
 * @example WordPress shortcode usage:
 * [hen-ui-section variant="light" gap="3xl"]
 *   [hen-ui-heading variant="h2"]Section Title[/hen-ui-heading]
 *   [hen-ui-text variant="b3"]Content here.[/hen-ui-text]
 * [/hen-ui-section]
 */
export const SectionShortcode: ShortCode<SectionShortcodeProps> = {
  balanced: true,
  component: ({
    variant = 'default',
    gap = '3xl',
    padding = 'none',
    rounded = 'false',
    children,
  }) => {
    const roundedValue =
      rounded === 'true'
        ? true
        : rounded === 'false' || rounded === 'none'
          ? false
          : rounded;

    return (
      <Section
        variant={variant}
        gap={gap}
        padding={padding}
        rounded={roundedValue}
      >
        {children}
      </Section>
    );
  },
};
